import Arrow from "./Icons/Arrow";

const Accordion = ({ id, title, open, onToggle, children, edit, className = '' }) => (
  <section className={`border mb-6 ${className}`}>
    <button
      type="button"
      aria-controls={id}
      aria-expanded={open}
      onClick={onToggle}
      className="w-full px-4 py-3 flex items-center gap-3 text-left"
    >
      <Arrow turn={open ? 'up' : 'down'}/>
      <span className={`text-lg font-semibold flex-1 ${edit ? 'text-gray-800' : 'text-gray-300'}`}>
        {title}
      </span>
    </button>
    {open && <div id={id} className="px-4 pb-4">{children}</div>}
  </section>
);

export default Accordion
